export default "__VITE_PUBLIC_ASSET__4d68f4c0__"